import { render, staticRenderFns } from "./SubmitResult.vue?vue&type=template&id=a241b65c&scoped=true"
import script from "./SubmitResult.vue?vue&type=script&lang=js"
export * from "./SubmitResult.vue?vue&type=script&lang=js"
import style0 from "./SubmitResult.vue?vue&type=style&index=0&id=a241b65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a241b65c",
  null
  
)

export default component.exports